import { render, staticRenderFns } from "./secondary-kpi-scenario-import.vue?vue&type=template&id=298b6e50&scoped=true"
import script from "./secondary-kpi-scenario-import.vue?vue&type=script&lang=ts"
export * from "./secondary-kpi-scenario-import.vue?vue&type=script&lang=ts"
import style0 from "./secondary-kpi-scenario-import.vue?vue&type=style&index=0&id=298b6e50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b6e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298b6e50')) {
      api.createRecord('298b6e50', component.options)
    } else {
      api.reload('298b6e50', component.options)
    }
    module.hot.accept("./secondary-kpi-scenario-import.vue?vue&type=template&id=298b6e50&scoped=true", function () {
      api.rerender('298b6e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula-step/secondary-kpi-tab/secondary-kpi-scenario-import.vue"
export default component.exports